<template>
    <simple-layout
        :models-loaded="true"
        name="Clients"
        imgPosY="-300"
    >
        <div class="headline">
            <h1>Clients</h1>
            <el-button type="primary" class="create-btn" @click="createClient">Créer un client</el-button>
        </div>
        <ns-paginate
            baseUrl="client/"
            :listFieldToDisplay="listFieldToDisplay"
            :displayCsvButton="false"
            :operationsColumn="operationsColumn"
            ref="nsPaginate"
        >
        </ns-paginate>
        <modal-create ref="modalCreate" @reload="reloadNsPaginate"></modal-create>
        <modal-create-facturation ref="modalCreateFacturation"></modal-create-facturation>
    </simple-layout>
</template>

<script>
import NsPaginate from 'fundation-app-vuejs/src/components/partials/nsPaginate';
import ModalCreate from './modal-create.vue';
import ModalCreateFacturation from '../Facturation/modal-create-facturation.vue';
export default {
    components: {
        NsPaginate,
        ModalCreate,
        ModalCreateFacturation,
    },
    data (){
        return {
            listFieldToDisplay: [
                {
                    key: 'name',
                    verbose: 'Nom',
                },
                {
                    key: 'simulation_counter',
                    verbose: 'Nombre de simulations à facturer',
                },
                {
                    key: 'billing_address',
                    verbose: 'Adresse de facturation',
                },
            ],
            editOptions: {
                verboseKey: {
                    name: 'Nom',
                    delivery_address: 'Adresse de livraison',
                    billing_address: 'Adresse de facturation',
                    siret: 'SIRET',
                    tva_number: 'N° TVA intra communautaire',
                    contact_edf: 'Correspondant EDF',
                    contact_edf_phone: 'N° de téléphone correspondant EDF',
                    contact_client: 'Contact client',
                    contact_client_phone: 'Téléphone',
                },
                keysToHide: ['simulation_counter_reference_datetime', 'simulation_counter', 'public', 'scopes', 'simulations_count_per_day']
            },
            operationsColumn: [
                {
                    icon: 'el-pencil',
                    text: 'Modifier client',
                    action: this.updateClient,
                },
                {
                    icon: 'el-ticket',
                    text: 'Créer facturation',
                    action: this.onCreateFacturation,
                },
                {
                    icon: 'el-ticket',
                    text: 'Réinitialiser compteur de simulations',
                    action: this.resetCounter,
                },
            ]
        };
    },
    methods: {
        createClient (){
            this.$refs.modalCreate.open();
        },
        updateClient (client){
            this.$refs.modalCreate.open(client);
        },
        reloadNsPaginate (){
            this.$refs.nsPaginate.loadContent();
        },
        onCreateFacturation (client){
            this.$refs.modalCreateFacturation.open(client);
        },
        resetCounter (client){
            this.$confirm('Êtes-vous sûr de vouloir réinitialiser le compteur de simulations?', 'Warning', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('patchItem', {
                    item: {
                        url: client.url,
                        uid: client.uid,
                        simulation_counter_reference_datetime: new Date(),
                        simulation_counter: 0,
                    },
                    model: 'clients'
                }).then(() => {
                    this.$notify.success({title: 'Compteur de simulations réinitialisé', message: `Le compteur de simulations pour le client ${client.name} à bien été réinitialisé.`});
                    this.reloadNsPaginate();
                }).catch((e) => {
                    console.error(e);
                    this.$notify.error({title: 'Erreur', message: `Erreur lors de la réinitialisation du compteur de simulations du client ${client.name}`});
                });
            });
        },
    },
};
</script>

<style lang="scss">
.headline {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Client/index.vue